<template>
  <div class="title_icon flex row middle">
    <!-- 刷新聊天信息 -->
    <!-- <i class="el-icon-refresh" style="font-size: 30px;margin-right: 5px;" @click="refreshFun()"></i> -->

    <el-dropdown trigger="click" class="dropdown">
      <div class="dropdown-trigger">
        <i class="el-icon-more"></i>
      </div>
      <el-dropdown-menu slot="dropdown" class="dropdownMenu">
        <template v-for="item in dropdownItems">
          <el-dropdown-item :key="item.id" @click.native="handleOperation(item)">
            <div class="dropdown-item">
              <i :class="item.icon" :style="{ color: item.iconColor }"></i>
              <span class="item-text">{{ item.name }}</span>
            </div>
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 举报弹窗 -->
    <el-dialog title="Report abuse" :visible.sync="reportDialogVisible" width="680px" :close-on-click-modal="false"
      :close-on-press-escape="false" class="report-dialog" top="3vh" :modal-append-to-body="false">
      <div class="report-content">
        <div class="report-header">
          <p class="report-intro">
            This is an abuse report. The user will not be blocked. Adding more details to your request will help us
            investigate the case of abuse more efficiently.
          </p>
        </div>

        <div class="user-info-section">
          <div class="user-info-item">
            <span class="user-label">User name:</span>
            <span class="user-value">{{ chatUserInfo.userDetail.name || 'Unknown' }}</span>
          </div>
          <div class="user-info-item">
            <span class="user-label">User ID:</span>
            <span class="user-value">{{ chatUserInfo.userId }}</span>
          </div>
        </div>

        <el-form :model="reportForm" :rules="reportRules" ref="reportForm" label-width="0" class="report-form">
          <el-form-item prop="reason" class="form-item-reason">
            <div class="form-label">Choose reason <span class="required">*</span></div>
            <el-select v-model="reportForm.reason" placeholder="Select option" class="reason-select"
              popper-class="reason-select-dropdown">
              <el-option v-for="item in reportReasons" :key="item.code" :label="item.description" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="comments" class="form-item-comments">
            <div class="form-label">Add comments <span class="required">*</span></div>
            <el-input v-model="reportForm.comments" type="textarea" :rows="3"
              placeholder="Please provide additional details..." class="comments-textarea" resize="none"></el-input>
          </el-form-item>

          <el-form-item class="form-item-upload">
            <div class="form-label">Attach file&nbsp;<span class="required" style="color: #8e8e8e;">(screenshot or other
                evidence)</span></div>
            <div class="upload-section">
              <el-upload class="upload-demo" :action="uploadAction" :http-request="customUpload"
                :on-error="handleUploadError" :before-upload="beforeUpload" :file-list="fileList" :limit="1"
                accept=".jpg,.jpeg,.png" :show-file-list="false">
                <el-button size="small" type="primary" class="upload-btn">选择文件</el-button>
              </el-upload>
              <div class="upload-tip">
                Download files in the following formats: JPG, PNG maximum 6 Mb size
              </div>
              <!-- 文件选择状态提示 -->
              <div v-if="fileSelected" class="file-selected-tip">
                <i class="el-icon-check" style="color: #67C23A; margin-right: 5px;"></i>
                文件已选择
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="reportDialogVisible = false" class="cancel-btn">Cancel</el-button>
        <el-button type="success" @click="submitReport" :loading="submitting" class="submit-btn">Submit</el-button>
      </div>
    </el-dialog>

    <!-- 拉黑确认弹窗 -->
    <el-dialog :title="`Are you sure you want to block ${chatUserInfo.userDetail?.name || 'this user'}?`"
      :visible.sync="blockDialogVisible" width="580px" :close-on-click-modal="false" :close-on-press-escape="false"
      class="block-dialog" top="10vh" :modal-append-to-body="false">
      <div class="block-content">
        <div class="block-form">
          <el-form :model="blockForm" :rules="blockRules" ref="blockForm" label-width="0" class="block-form-content">
            <el-form-item prop="reason" class="form-item-reason-block">
              <div class="reason-label">Please tell us what happened <span class="required">*</span></div>
              <el-input v-model="blockForm.reason" type="textarea" :rows="4" placeholder="Type your message here..."
                class="reason-textarea" resize="none"></el-input>
              <div class="validation-tip">Minimum 25 characters</div>
              <div class="disclaimer">This information will be recorded by the platform</div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="blockDialogVisible = false" class="cancel-btn">Cancel</el-button>
        <el-button type="danger" @click="confirmBlock" :loading="blocking" class="block-btn">Block</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 用户操作组件
 * 提供用户管理功能：置顶、收藏、举报、拉黑等
 * 
 * @emits pin-updated - 置顶状态更新
 * @emits bookmark-updated - 收藏状态更新  
 * @emits user-blocked - 用户被拉黑
 * @emits user-operation - 用户操作事件
 */
import { reSubscribe } from '@/api/user';
import { delChat } from '@/api/dialogue';
import store from '@/store';
import { bookmarkUser, pinUser, unpinUser, getAbuseReportReasonList, reportUser, blockUser } from '@/api/talkytimes/user';
import { uploadImage } from '@/api/talkytimes/message';
import { addContactList, removeContactList } from '@/api/talkytimes/user';

export default {
  name: 'OperationGroup',
  props: {
    chatUserInfo: {
      type: Object,
      required: true
    },
    isShowingPinnedMessages: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reportDialogVisible: false,
      submitting: false,
      reportReasons: [],
      reportForm: {
        reason: '',
        comments: '',
        fileUrl: '',
        fileKey: '',
        fileSize: ''
      },
      reportRules: {
        reason: [
          { required: true, message: 'Please select a reason', trigger: 'change' }
        ],
        comments: [
          { required: true, message: 'Please add comments', trigger: 'blur' }
        ]
      },
      fileList: [],
      uploadAction: '', // 不使用action，改为手动上传
      fileSelected: false, // 文件是否已选择
      blockDialogVisible: false,
      blocking: false,
      blockForm: {
        reason: ''
      },
      blockRules: {
        reason: [
          { required: true, message: 'Please tell us what happened', trigger: 'blur' },
          { min: 25, message: 'Minimum 25 characters required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    isUserBookmarked() {
      const isBookmarked = this.chatUserInfo?.isBookmarked;
      return isBookmarked == 1 || isBookmarked === true;
    },
    dropdownItems() {
      const vipContacts = this.chatUserInfo.vipContacts;
      const items = [
        // { id: 0, name: '愿望单', icon: 'el-icon-star-on', iconColor: '#409EFF' },
        // { id: 1, name: '收藏信息', icon: 'el-icon-star-off', iconColor: '#409EFF' },
        { id: 2, name: this.chatUserInfo.isPinned ? '取消置顶' : '置顶', icon: 'el-icon-top', iconColor: '#409EFF' },
        {
          id: 3,
          name: this.isUserBookmarked ? '取消收藏' : '收藏',
          icon: 'el-icon-collection',
          iconColor: this.isUserBookmarked ? '#E6A23C' : '#409EFF',
        },
        { id: 6, name: this.isShowingPinnedMessages ? '返回聊天' : '收藏消息', icon: this.isShowingPinnedMessages ? 'el-icon-chat-line-round' : 'el-icon-star-on', iconColor: '#409EFF' },
        { id: 7, name: '媒体记录', icon: 'el-icon-picture', iconColor: '#409EFF' },
        { id: 4, name: '举报', icon: 'el-icon-warning', iconColor: '#606266' },
        { id: 5, name: '拉黑', icon: 'el-icon-close', iconColor: '#606266' },
      ];

      // 只有当vipContacts为true时才添加VIP选项
      if (vipContacts) {
        items.unshift({
          id: 1,
          name: this.chatUserInfo.userDetail.isVip ? '取消VIP' : '添加VIP',
          icon: 'el-icon-star-on',
          iconColor: '#FFD700'
        });
      }

      return items;
    }
  },
  mounted() {
    this.getReportReasons();
  },
  methods: {
    // 添加VIP
    addVip() {
      addContactList({
        idUser: this.chatUserInfo.userId,
        name: 'vip'
      }).then((res) => {
        this.$message.success('已添加VIP');
      }).catch((error) => {
        console.error('添加VIP失败:', error);
        this.$message.error('添加VIP失败');
      });
    },

    // 取消VIP
    removeVip() {
      removeContactList({
        idUser: this.chatUserInfo.userId,
        name: 'vip'
      }).then((res) => {
        this.$message.success('已取消VIP');
      }).catch((error) => {
        console.error('取消VIP失败:', error);
        this.$message.error('取消VIP失败');
      });
    },
    // 获取举报原因列表
    getReportReasons() {
      console.log('开始获取举报原因列表...');
      getAbuseReportReasonList().then((res) => {
        console.log('举报原因接口返回:', res);
        if (res.data && Array.isArray(res.data)) {
          // 数据直接在 res.data 中
          this.reportReasons = res.data;
          console.log('举报原因列表已更新:', this.reportReasons);
        } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // 数据在 res.data.data 中
          this.reportReasons = res.data.data;
          console.log('举报原因列表已更新:', this.reportReasons);
        } else {
          console.warn('举报原因接口返回数据格式异常:', res);
          console.log('尝试使用 res 作为数据源');
          if (Array.isArray(res)) {
            this.reportReasons = res;
            console.log('使用 res 作为举报原因列表:', this.reportReasons);
          }
        }
      }).catch((error) => {
        console.error('获取举报原因失败:', error);
        this.$message.error('获取举报原因失败，请稍后重试');
      });
    },

    // 处理操作按钮点击
    handleOperation(item) {
      console.log('操作:', item.name);
      console.log('用户信息:', this.chatUserInfo);
      // console.log('用户信息:', this.chatUserInfo.userDetail.isVip);
      // return
      switch (item.id) {
        case 1:
          // VIP相关操作
          if (this.chatUserInfo.userDetail.isVip) {
            this.removeVip();
          } else {
            this.addVip();
          }
          break;
        case 2:
          // 置顶/取消置顶
          this.handlePinTop();
          break;
        case 3:
          // 收藏/取消收藏
          this.handleCollect();
          break;
        case 4:
          // 举报
          this.handleReport();
          break;
        case 5:
          // 拉黑
          this.handleBlock();
          break;
        case 6:
          // 收藏消息/返回聊天
          this.handleViewPinnedMessages();
          break;
        case 7:
          // 媒体记录
          this.handleViewMediaHistory();
          break;
        default:
          break;
      }
    },

    // 愿望单功能
    handleWishlist() {
      this.$message.info('愿望单功能开发中...');
    },

    // 收藏信息功能
    handleFavorite() {
      this.$message.info('收藏信息功能开发中...');
    },

    // 查看收藏的消息功能
    handleViewPinnedMessages() {
      this.$emit('view-pinned-messages', this.chatUserInfo.userId);
    },

    // 查看媒体记录功能
    handleViewMediaHistory() {
      this.$emit('view-media-history', this.chatUserInfo.userId);
    },

    // 置顶功能
    handlePinTop() {
      if (this.chatUserInfo.isPinned) {
        // 取消置顶
        unpinUser({
          idInterlocutor: this.chatUserInfo.userId
        }).then((res) => {
          this.$message.success('已取消置顶');
          // 立即更新本地状态
          this.$set(this.chatUserInfo, 'isPinned', false);
          this.$emit('pin-updated', false);
          this.$emit('user-operation', { type: 'unpin', userId: this.chatUserInfo.userId });
        }).catch((error) => {
          console.error('取消置顶失败:', error);
          this.$message.error('取消置顶失败');
        });
      } else {
        // 置顶
        pinUser({
          idInterlocutor: this.chatUserInfo.userId
        }).then((res) => {
          this.$message.success('已置顶');
          // 立即更新本地状态
          this.$set(this.chatUserInfo, 'isPinned', true);
          this.$emit('pin-updated', true);
          this.$emit('user-operation', { type: 'pin', userId: this.chatUserInfo.userId });
        }).catch((error) => {
          console.error('置顶失败:', error);
          this.$message.error('置顶失败');
        });
      }
    },

    // 收藏功能
    handleCollect() {
      if (this.isUserBookmarked) {
        // 取消收藏
        bookmarkUser({
          idRegularUser: this.chatUserInfo.userId,
          bookmark: false
        }).then((res) => {
          this.$message.success('已取消收藏');
          // 立即更新本地状态
          this.$set(this.chatUserInfo, 'isBookmarked', 0);
          this.$emit('bookmark-updated', false);
          this.$emit('user-operation', { type: 'unbookmark', userId: this.chatUserInfo.userId });
        }).catch((error) => {
          console.error('取消收藏失败:', error);
          this.$message.error('取消收藏失败');
        });
      } else {
        // 收藏
        bookmarkUser({
          idRegularUser: this.chatUserInfo.userId,
          bookmark: true
        }).then((res) => {
          this.$message.success('已收藏');
          // 立即更新本地状态
          this.$set(this.chatUserInfo, 'isBookmarked', 1);
          this.$emit('bookmark-updated', true);
          this.$emit('user-operation', { type: 'bookmark', userId: this.chatUserInfo.userId });
        }).catch((error) => {
          console.error('收藏失败:', error);
          this.$message.error('收藏失败');
        });
      }
    },

    // 举报功能
    handleReport() {
      // 每次打开举报弹窗时都重新获取举报原因列表
      this.getReportReasons();
      this.reportDialogVisible = true;
      this.resetReportForm();
    },

    // 重置举报表单
    resetReportForm() {
      this.reportForm = {
        reason: '',
        comments: '',
        fileUrl: '',
        fileKey: '',
        fileSize: ''
      };
      this.fileList = [];
      this.fileSelected = false; // 重置文件选择状态
      this.$nextTick(() => {
        this.$refs.reportForm && this.$refs.reportForm.clearValidate();
      });
    },



    // 文件上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败');
    },

    // 自定义上传方法
    async customUpload(options) {
      try {
        const formData = new FormData();
        formData.append('file', options.file);

        // 使用uploadImage接口上传
        const response = await uploadImage(formData);

        console.log('上传响应:', response); // 添加调试日志

        if (response && response.key) {
          // 上传成功，直接处理响应数据
          this.reportForm.fileUrl = response.full_size || response.url || (options.file && options.file.url);
          this.reportForm.fileKey = response.key;
          this.reportForm.fileSize = response.size;
          this.fileSelected = true; // 设置文件已选择状态
          this.$message.success('文件上传成功');

          // 调用Element UI的成功回调
          options.onSuccess(response);
        } else {
          throw new Error('上传失败，未获取到文件key');
        }
      } catch (error) {
        console.error('文件上传失败:', error);
        this.$message.error('文件上传失败');
        options.onError(error);
      }
    },

    // 上传前检查
    beforeUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt6M = file.size / 1024 / 1024 < 6;

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!');
        return false;
      }
      if (!isLt6M) {
        this.$message.error('图片大小不能超过 6MB!');
        return false;
      }
      return true;
    },

    // 提交举报
    submitReport() {
      this.$refs.reportForm.validate((valid) => {
        if (valid) {
          this.submitting = true;

          // 构建举报数据
          const reportData = {
            idInterlocutor: this.chatUserInfo.userId,
            reason: this.reportForm.reason,
            comments: this.reportForm.comments,
            fileUrl: this.reportForm.fileUrl
          };
          console.log('举报数据:', reportData);
          // return
          reportUser(reportData).then(res => {
            this.submitting = false;
            this.$message.success('举报提交成功');
            this.reportDialogVisible = false;
            this.resetReportForm();
            this.$emit('user-operation', { type: 'report', userId: this.chatUserInfo.userId, data: reportData });
          }).catch(error => {
            this.submitting = false;
            console.error('举报提交失败:', error);
            this.$message.error('举报提交失败，请稍后重试');
          });
        }
      });
    },

    // 拉黑功能
    handleBlock() {
      this.blockDialogVisible = true;
      this.resetBlockForm();
    },

    // 重置拉黑表单
    resetBlockForm() {
      this.blockForm.reason = '';
      this.$nextTick(() => {
        this.$refs.blockForm && this.$refs.blockForm.clearValidate();
      });
    },

    // 确认拉黑
    confirmBlock() {
      this.$refs.blockForm.validate((valid) => {
        if (valid) {
          this.blocking = true;
          let params = {
            idInterlocutor: this.chatUserInfo.userId,
            comment: this.blockForm.reason
          }
          console.log('拉黑数据:', params);
          // return
          blockUser(params).then(res => {
            this.blocking = false;
            this.$message.success('用户已拉黑');
            this.blockDialogVisible = false;
            this.resetBlockForm();
            console.log('拉黑数据:', res);
            // 触发拉黑成功事件
            this.$emit('user-blocked', this.chatUserInfo.userId);
          }).catch(error => {
            this.blocking = false;
            console.error('拉黑失败:', error);
            this.$message.error('拉黑失败，请稍后重试');
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {

  .el-dialog__header {
    padding: 20px 24px 0 24px !important;
  }

  .el-dialog {
    border-radius: 12px !important;
    overflow: hidden !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
    backdrop-filter: blur(10px) !important;
  }

  .el-dialog__wrapper {
    backdrop-filter: blur(8px) !important;
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .el-form-item__label {
    font-weight: 600 !important;
    color: #374151 !important;
  }

  .el-select .el-input__inner {
    border-radius: 8px !important;
    border: 2px solid #e2e8f0 !important;
    transition: all 0.3s ease !important;
  }

  .el-select .el-input__inner:focus {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15) !important;
  }
}

.title_icon {
  display: flex;
  align-items: center;
}

.dropdown {
  margin-left: 5px;
}

.dropdown-trigger {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.dropdown-trigger:hover {
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.25);
  transform: translateY(-2px);
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
}

.dropdown-trigger i {
  font-size: 18px;
  color: #409EFF;
}

.dropdownMenu {
  min-width: 140px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: none;
  padding: 8px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 0 4px;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
  transform: translateX(4px);
  border-radius: 6px;
  margin: 0 4px;
}

.dropdown-item i {
  font-size: 16px;
  margin-right: 12px;
  width: 16px;
  text-align: center;
}

.item-text {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

/* 举报弹窗样式 */
.report-dialog .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 24px 28px 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.report-dialog .el-dialog__header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 12px 12px 0 0;
  pointer-events: none;
}

.report-dialog .el-dialog__header .el-dialog__title {
  color: white;
  font-size: 20px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.report-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.report-dialog .el-dialog__header .el-dialog__headerbtn:hover .el-dialog__close {
  color: #f0f0f0;
  transform: scale(1.1);
}

.report-dialog .el-dialog__body {
  padding: 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  max-height: 80vh;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
}

.report-content {
  height: auto;
  overflow: visible;
  padding: 28px 32px;
}

.report-header {
  margin-bottom: 28px;
}

.report-intro {
  color: #475569;
  line-height: 1.7;
  margin: 0;
  font-size: 15px;
  text-align: left;
  padding: 20px 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  border-left: 4px solid #667eea;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
  overflow: hidden;
}

.report-intro::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.user-info-section {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-radius: 12px;
  margin-bottom: 28px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.user-info-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

.user-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
}

.user-info-item:last-child {
  border-bottom: none;
}

.user-label {
  font-weight: 600;
  color: #334155;
  font-size: 14px;
  position: relative;
}

.user-value {
  color: #64748b;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.7);
  padding: 6px 12px;
  border-radius: 8px;
  font-family: inherit;
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.report-form {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 20px 16px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
  overflow: hidden;
}

.report-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.form-item-reason .reason-select {
  width: 100%;
}

.form-label {
  font-size: 14px;
  color: #374151;
  margin-bottom: 6px;
  font-weight: 600;
  display: block;
  text-align: left;
}

.form-label .required {
  color: #ef4444;
  font-weight: 700;
  margin-left: 2px;
}

.form-item-reason {
  margin-bottom: 16px;
}

.form-item-reason .el-form-item__content {
  margin-bottom: 6px;
  padding-left: 0;
}

.form-item-comments {
  margin-bottom: 16px;
}

.form-item-upload {
  margin-bottom: 8px;
}

.form-item-comments .el-form-item__content {
  padding-left: 0;
}

.form-item-upload .el-form-item__content {
  padding-left: 0;
}

.block-form-content .el-form-item__content {
  padding-left: 0;
}

.form-item-comments .comments-textarea {
  border-radius: 12px;
}

.form-item-comments .comments-textarea .el-textarea__inner {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.form-item-comments .comments-textarea .el-textarea__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15), 0 4px 16px rgba(102, 126, 234, 0.1);
  background: #ffffff;
}

.form-item-upload .upload-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.form-item-upload .upload-label {
  color: #64748b;
  font-size: 13px;
  margin-bottom: 12px;
  font-style: italic;
  font-weight: 500;
  align-self: flex-start;
}

.form-item-upload .upload-btn {
  border-radius: 12px;
  font-weight: 600;
  padding: 12px 24px;
  font-size: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
  align-self: flex-start;
}

.form-item-upload .upload-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.form-item-upload .upload-tip {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 10px 14px;
  border-radius: 10px;
  border-left: 4px solid #667eea;
  margin-top: 6px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  align-self: flex-start;
  width: 100%;
}

.dialog-footer {
  text-align: right;
  padding: 24px 32px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-top: 1px solid rgba(102, 126, 234, 0.1);
  border-radius: 0 0 12px 12px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.04);
}

.cancel-btn {
  margin-right: 16px;
  border-radius: 10px;
  padding: 12px 24px;
  font-weight: 600;
  border: 2px solid #e2e8f0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #64748b;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.cancel-btn:hover {
  border-color: #cbd5e1;
  color: #334155;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.submit-btn {
  border-radius: 10px;
  padding: 12px 24px;
  font-weight: 600;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

/* 下拉框样式优化 */
.reason-select-dropdown .el-select-dropdown__item {
  padding: 10px 16px;
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

.reason-select-dropdown .el-select-dropdown__item:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  transform: translateX(4px);
}

.reason-select-dropdown .el-select-dropdown__item.selected {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dropdown-trigger {
    width: 28px;
    height: 28px;
  }

  .dropdown-trigger i {
    font-size: 16px;
  }

  .dropdownMenu {
    min-width: 120px;
  }

  .dropdown-item {
    padding: 8px 12px;
  }

  .item-text {
    font-size: 13px;
  }

  .report-dialog,
  .block-dialog {
    width: 95% !important;
    margin: 2vh auto !important;
  }

  .report-dialog .el-dialog__body,
  .block-dialog .el-dialog__body {
    padding: 0 !important;
  }

  .report-content,
  .block-content {
    padding: 20px 24px !important;
  }

  .report-form,
  .block-form {
    padding: 16px 12px !important;
  }

  .dialog-footer {
    padding: 20px 24px !important;
  }

  .cancel-btn,
  .submit-btn,
  .block-btn {
    padding: 10px 20px !important;
    font-size: 13px !important;
  }
}

/* 拉黑弹窗样式 */
.block-dialog .el-dialog__header {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 24px 28px 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.3);
}

.block-dialog .el-dialog__header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 12px 12px 0 0;
  pointer-events: none;
}

.block-dialog .el-dialog__header .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.block-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.block-dialog .el-dialog__header .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fecaca;
  transform: scale(1.1);
}

.block-dialog .el-dialog__body {
  padding: 0;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 0 0 12px 12px;
}

.block-content {
  padding: 28px 32px;
}

.block-form {
  background: linear-gradient(135deg, #ffffff 0%, #fef2f2 100%);
  padding: 20px 16px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.1);
  position: relative;
  overflow: hidden;
}

.block-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
}

.form-item-reason-block {
  margin-bottom: 0;
}

.reason-label {
  font-size: 15px;
  color: #374151;
  margin-bottom: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.required {
  color: #ef4444;
  font-weight: 700;
  font-size: 16px;
}

.reason-textarea {
  margin-bottom: 8px;
}

.reason-textarea .el-textarea__inner {
  border: 2px solid #fecaca;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  resize: none;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.reason-textarea .el-textarea__inner:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.15), 0 4px 16px rgba(239, 68, 68, 0.1);
  background: #ffffff;
}

.validation-tip {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.5;
  font-weight: 500;
}

.disclaimer {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  font-weight: 500;
  padding: 8px 12px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 8px;
  border-left: 4px solid #ef4444;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.block-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  color: white;
  font-weight: 600;
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  transition: all 0.3s ease;
}

.block-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.block-btn:focus {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* 文件选择状态提示样式 */
.file-selected-tip {
  margin-top: 8px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  color: #0369a1;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
